import { GetStrategyIssuesCount } from '../shell-communication/operations/strategies/get-strategy-issues-count.class';
import { GetStrategyIssuesCountResponse } from '../shell-communication/dtos/get-strategy-issues-count-response.interface';

export abstract class StrategiesIssuesBackendService {
  abstract getStrategiesIssues(qry: GetStrategyIssuesCount, shellId?: string): Promise<GetStrategyIssuesCountResponse>;
}
